<template>
  <Layout>
    <div class="container-of-future">
      <div class="future-req">
        <q-card square>
          <div class="future-header">Manheim Valuation Search</div>
          <div class="future-content">
            <q-form @submit.prevent="onSubmit" ref="form">
              <div class="row q-col-gutter-md">
                <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
                  <q-input
                    hide-bottom-space
                    label-color="black"
                    lazy-rules
                    color="black"
                    input-style="color:#000 !important;"
                    :rules="[val => (val !== null && val !== '') || 'Please type vin']"
                    outlined
                    label="VIN*"
                    v-model="vin"
                  ></q-input>
                </div>
                <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
                  <q-input
                    hide-bottom-space
                    label-color="black"
                    lazy-rules
                    color="black"
                    input-style="color:#000 !important;"
                    :rules="[
                      val => (val !== null && val !== '') || 'Please type mileage',
                      val => val > 0 || 'Mileage must bigger than 0'
                    ]"
                    outlined
                    type="number"
                    label="Mileage*"
                    v-model="mileage"
                  ></q-input>
                </div>
                <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
                  <q-select
                    label="Select Region*"
                    input-style="color:#000 !important;"
                    v-model="region"
                    outlined
                    :disable="regions.length === 0"
                    label-color="black"
                    color="black"
                    :rules="[regionChecker]"
                    :option-label="reg => reg.name"
                    hide-bottom-space
                    :options="regions"
                    lazy-rules
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-italic text-grey">
                          There is no options.
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-select>
                </div>
                <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12" v-if="regions.length > 0">
                  <q-btn
                    push
                    color="white"
                    text-color="primary"
                    outline
                    v-for="(region, index) in selecteds"
                    :key="index"
                    @remove="del(index)"
                    :label="region.code ? region.code : region.name"
                    @click="selecteds.splice(index, 1)"
                    style="margin-right: 5px; margin-bottom: 5px"
                  >
                    <q-badge transparent align="middle">{{ region.vin }}</q-badge>
                  </q-btn>
                </div>
                <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
                  <q-btn
                    :disable="loading || selecteds.length === 0"
                    style="width: 50%"
                    push
                    color="positive"
                    label="Search"
                    @click="search"
                  />
                  <q-btn type="submit" :disable="loading" style="width: 50%" push color="info" label="Add" />
                </div>
              </div>
            </q-form>
          </div>
        </q-card>
      </div>
      <div class="result-of-future">
        <div id="table-scroll" ref="tablev2" v-if="vehicles.length > 0 && !loading" class="table-scroll">
          <table id="main-table" class="main-table" v-if="vehicles.length > 0">
            <tr>
              <th colspan="9"></th>
              <th colspan="4">Manheim Current</th>
              <th colspan="10">Manheim Historical Averages</th>
              <th colspan="4">Manheim Forecast</th>
            </tr>
            <tr>
              <th colspan="9">Vehicles</th>
              <th colspan="2">Manheim Data</th>
              <th colspan="2">Manheim Market Pricing</th>
              <th colspan="2">Last 30 Days</th>
              <th colspan="2">Last Month</th>
              <th colspan="2">Last Two Months</th>
              <th colspan="2">Last Six Months</th>
              <th colspan="2">Last Year</th>
              <th colspan="2">Next Month</th>
              <th colspan="2">Next Year</th>
            </tr>
            <tr>
              <!-- skip 1st column because it merges vertically -->
              <th>VIN</th>
              <th>YEAR</th>
              <th>MAKE</th>
              <th>MODEL</th>
              <th>TRIM</th>
              <th>Sub Series</th>
              <th>Current Mileage</th>
              <th>AVG CR</th>
              <th>Vehicle Condition</th>
              <th>Region</th>
              <th>Avg Mileage</th>
              <th>Auction</th>
              <th>Retail</th>
              <th>Avg Mileage</th>
              <th>Auction</th>
              <th>Avg Mileage</th>
              <th>Auction</th>
              <th>Avg Mileage</th>
              <th>Auction</th>
              <th>Avg Mileage</th>
              <th>Auction</th>
              <th>Avg Mileage</th>
              <th>Auction</th>
              <th>Auction</th>
              <th>Retail</th>
              <th>Auction</th>
              <th>Retail</th>
            </tr>
            <tr v-for="(v, index) in vehicles" @dblclick="selectVehicleGroup(v, index)" :key="index">
              <td style="min-width: 100px">
                <div style="display: flex">
                  <div>
                    <i
                      :class="v.children && v.children.length > 0 ? 'fas fa-chevron-down' : 'fas fa-minus'"
                      style="margin-right: 5px"
                    ></i>
                  </div>
                  <div>{{ v.vin }}</div>
                </div>
              </td>
              <td style="min-width: 100px">
                {{ v.description.model_year }}
              </td>
              <td style="min-width: 100px">
                {{ v.description.brand }}
              </td>
              <td style="min-width: 100px">
                {{ v.description.model }}
              </td>
              <td style="min-width: 100px">
                {{ v.description.trim }}
              </td>
              <td style="min-width: 100px">
                {{ v.description.sub_series }}
              </td>
              <td style="min-width: 100px">
                {{ v.mileage.toLocaleString('en-US') }}
              </td>
              <td style="min-width: 100px">
                {{ v.average_grade ? (v.average_grade / 10).toFixed(2) : '-' }}
              </td>
              <td style="min-width: 100px">
                {{ firstCharUpper(v.condition) }}
                <q-menu>
                  <q-list style="min-width: 100px">
                    <q-item
                      v-for="cond in conditions"
                      :key="cond.val"
                      @click="updateVehicleCond(index, cond.val)"
                      clickable
                      v-close-popup
                    >
                      <q-item-section>
                        <span :style="v.condition === cond.val ? 'color:#1976D2' : ''">{{ cond.name }}</span>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </q-menu>
              </td>
              <td style="min-width: 100px">
                {{ v.region }}
              </td>
              <td style="min-width: 100px">
                {{ v.average_mileage.toLocaleString('en-US') }}
              </td>
              <td style="min-width: 100px">
                {{
                  v.auction[v.condition].toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  })
                }}
              </td>
              <td style="min-width: 100px">
                {{
                  v.retail[v.condition].toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  })
                }}
              </td>
              <td style="min-width: 100px">
                {{ v.historical_averages.last_30_days.mileage.toLocaleString('en-US') }}
              </td>
              <td style="min-width: 100px">
                {{
                  v.historical_averages.last_30_days.price.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  })
                }}
              </td>
              <td style="min-width: 100px">
                {{ v.historical_averages.last_month.mileage.toLocaleString('en-US') }}
              </td>
              <td style="min-width: 100px">
                {{
                  v.historical_averages.last_month.price.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  })
                }}
              </td>
              <td style="min-width: 100px">
                {{ v.historical_averages.last_two_months.mileage.toLocaleString('en-US') }}
              </td>
              <td style="min-width: 100px">
                {{
                  v.historical_averages.last_two_months.price.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  })
                }}
              </td>
              <td style="min-width: 100px">
                {{ v.historical_averages.last_six_months.mileage.toLocaleString('en-US') }}
              </td>
              <td style="min-width: 100px">
                {{
                  v.historical_averages.last_six_months.price.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  })
                }}
              </td>
              <td style="min-width: 100px">
                {{ v.historical_averages.last_year.mileage.toLocaleString('en-US') }}
              </td>
              <td style="min-width: 100px">
                {{
                  v.historical_averages.last_year.price.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  })
                }}
              </td>

              <td style="min-width: 100px">
                {{
                  v.forecast.next_month.auction.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  })
                }}
              </td>
              <td style="min-width: 100px">
                {{
                  v.forecast.next_month.retail.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  })
                }}
              </td>
              <td style="min-width: 100px">
                {{
                  v.forecast.next_year.auction.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  })
                }}
              </td>
              <td style="min-width: 100px">
                {{
                  v.forecast.next_year.retail.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  })
                }}
              </td>
            </tr>
          </table>
        </div>
        <div class="loading-infinite" v-if="loading">
          <div>
            <q-spinner-facebook color="primary" size="40px" />
            <div class="text-grey-7">Loading</div>
          </div>
        </div>
        <q-card style="padding: 15px" v-if="vehicles.length === 0 && !loading">
          <empty-value name="Manheim searched data." description="Feel free to search vehicles."></empty-value>
        </q-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../components/Layout'
import EmptyValue from '../components/EmptyValue'
import draggable from 'vuedraggable'
import axios from '../axios'
import FutureValueId from '../components/FutureValueId'

export default {
  data() {
    return {
      leftInterval: null,
      rightInterval: null,
      selectedVehicleGroup: [],
      conditions: [
        {
          name: 'Above',
          val: 'excellent'
        },
        {
          name: 'Average',
          val: 'good'
        },
        {
          name: 'Below',
          val: 'fair'
        }
      ],
      vehicles: [],
      loading: false,
      vin: '',
      mileage: '',
      region: null,
      selecteds: [],
      regions: []
    }
  },
  components: {
    EmptyValue,
    Layout,
    FutureValueId,
    draggable
  },
  mounted() {
    this.getRegions()
  },
  methods: {
    shiftRight() {
      this.rightInterval = setInterval(() => {
        this.$refs.tablev2.scrollLeft += 50
      }, 50)
    },
    shiftRightEnd() {
      clearInterval(this.rightInterval)
    },
    shiftLeft() {
      this.leftInterval = setInterval(() => {
        this.$refs.tablev2.scrollLeft -= 50
      }, 50)
    },
    shiftLeftEnd() {
      clearInterval(this.leftInterval)
    },
    selectVehicleGroup(veh, index) {
      let _vehicles = [...this.vehicles]
      if (!veh.children) return
      const [first] = veh.children
      const { vin } = first
      const isExpanded = _vehicles.filter(v => v.vin === vin).length > 1
      if (!isExpanded) {
        if (veh.children) this.vehicles.splice(index + 1, 0, ...veh.children)
      } else {
        for (const vehicle of veh.children) {
          this.vehicles = this.vehicles.filter(v => v.vin !== vehicle.vin)
          this.vehicles.splice(index, 0, veh)
        }
      }
    },
    updateVehicleCond(index, cond, sub = null) {
      if (!sub) {
        this.vehicles.splice(index, 1, {
          ...this.vehicles[index],
          condition: cond
        })
      } else {
        this.selectedVehicleGroup.splice(index, 1, {
          ...this.selectedVehicleGroup[index],
          condition: cond
        })
      }
    },
    del(index) {
      this.selecteds.splice(index, 1)
    },
    onSubmit() {
      this.selecteds.push({
        vin: this.vin,
        mileage: parseInt(this.mileage),
        region: this.region.code
      })
      this.reset()
      this.$refs.form.resetValidation()
    },
    reset() {
      this.vin = ''
      this.mileage = ''
      this.region = null
    },
    firstCharUpper(v) {
      return v.charAt(0).toUpperCase() + v.slice(1)
    },
    async search() {
      try {
        const body = [...this.selecteds]
        this.loading = true
        this.selectedVehicleGroup = []
        const { data } = await axios.post('/queries/manheim/search', {
          vehicles: body
        })
        const vehicles = []
        for (const { items, vehicle, error } of data.data) {
          if (items) {
            for (const item of items) {
              vehicles.push({
                ...vehicle,
                condition: 'good',
                ...item
              })
            }
          } else {
            this.$q.notify({
              message: 'vin: ' + vehicle?.vin + ' ' + error,
              timeout: 3000,
              position: 'top-right',
              progress: true,
              type: 'negative'
            })
          }
        }
        this.vehicleGroupper(vehicles)
        this.loading = false
      } catch (error) {
        this.loading = false
        this.vehicles = []
        const errors = error.response?.data?.errors || [error.response.data.message] || ['Something went wrong']

        let message = ''

        function errorHandler(obj) {
          try {
            for (const key in obj) {
              if (Object.hasOwnProperty.call(obj, key)) {
                const element = obj[key]
                if (Array.isArray(element)) {
                  message = element[0]
                } else if (typeof element === 'object') {
                  errorHandler(element)
                } else {
                  message = element
                }
              }
            }
          } catch (error) {
            message = 'Something went wrong'
          }
        }

        errorHandler(errors)

        this.$q.notify({
          message,
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      }
    },
    vehicleGroupper(vehicles) {
      const vehicleGroups = []
      for (const [index, vehicle] of vehicles.entries()) {
        const { vin } = vehicle
        if (index === 0) vehicleGroups.push({ ...vehicle, children: [] })
        else {
          const index = vehicleGroups.findIndex(v => v.vin === vin)
          index >= 0
            ? vehicleGroups[index].children.push({ ...vehicle })
            : vehicleGroups.push({ ...vehicle, children: [] })
        }
      }
      this.vehicles = vehicleGroups
    },
    regionChecker(val) {
      if (val === null) return 'Please choose region'
    },
    async getRegions() {
      const { data } = await axios.get('regions')
      this.regions = data.data
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-item-icon-4 {
  z-index: 999 !important;
  position: fixed !important;
  top: 300px !important;
}
.right-0 {
  right: 0;
}
.hide {
  display: none;
}
.future-header {
  font-size: 18px;
  font-weight: bold;
  padding: 10px 13px;
  text-align: left;
  align-items: center;
  display: flex;
  border-bottom: 1px solid #ccc;
}
.future-content {
  padding: 10px;
}

.container-of-future {
  display: flex;
  flex: 1;
  flex-flow: row nowrap;
  .future-req {
    transform: translateZ(0);
    position: fixed;
    width: 250px;
    z-index: 15;
  }
  .result-of-future {
    margin: 0 10px;
    margin-left: 270px;
    width: calc(100% - 250px);
  }
}

@media only screen and (max-width: 1023px) {
  .container-of-future {
    display: flex;
    flex: 1;
    flex-flow: column nowrap;
    .future-req {
      transform: translateZ(0);
      position: relative;
      width: 100%;
    }
    .result-of-future {
      margin: 10px 0;
      width: 100%;
    }
  }
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.flip-list-move {
  transition: transform 500ms;
}
</style>
